import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

function TimeDropdown({ time, selectedDate, selectedTime, handleTimeChange }) {
  // Function to round to the nearest 30-minute increment, but keep exact 30-minute times
  const roundToNearest30 = time => {
    // console.log(time?.toString());
    const minute = time.minute();
    // If minute is already 0 or 30, return the time as it is
    if (minute === 0 || minute === 30) {
      return time;
    }
    // Otherwise, round up to the next 30-minute mark
    const remainder = 30 - (minute % 30);
    return moment(time).add(remainder, 'minutes').startOf('minute');
  };

  // Function to generate time intervals in 30-minute increments
  const generateTimes = () => {
    const times = [];
    const periods = ['AM', 'PM'];

    for (let period of periods) {
      for (let hour = 1; hour <= 12; hour++) {
        times.push(`${hour < 10 ? '0' + hour : hour}:00 ${period}`);
        times.push(`${hour < 10 ? '0' + hour : hour}:30 ${period}`);
      }
    }

    return times;
  };

  // Get the nearest time to now when component mounts or when 'time' prop changes
  useEffect(() => {
    // console.log('time', time);
    if (time) {
      const nearestTime = roundToNearest30(moment(time));
      handleTimeChange(nearestTime.format('hh:mm A'));
    }
  }, [time, handleTimeChange]);

  // Function to disable past times for the current day
  const isPastTime = time => {
    if (moment(selectedDate).isSame(moment(), 'day')) {
      const currentMoment = moment(); // Current time
      const [hour, minute, period] = time.split(/[:\s]/); // Split time
      const timeMoment = moment(`${hour}:${minute} ${period}`, 'h:mm A'); // Time in dropdown

      // Adjust the comparison to ensure date + time comparison
      const fullTimeMoment = moment(selectedDate)
        .hour(timeMoment.hour())
        .minute(timeMoment.minute());

      return fullTimeMoment.isBefore(currentMoment); // Disable past times
    }
    return false;
  };

  return (
    <select
      value={selectedTime}
      onChange={e => handleTimeChange(e.target.value)}
      style={{
        fontSize: 16,
        fontWeight: 400,
        textAlign: 'center',
        border: '0px solid rgba(0, 0, 0, 0.1)',
        outline: 0
      }}
    >
      {generateTimes().map((time, index) => (
        <option key={index} value={time} disabled={isPastTime(time)}>
          {time}
        </option>
      ))}
    </select>
  );
}

TimeDropdown.propTypes = {
  time: PropTypes.instanceOf(Date).isRequired,
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  selectedTime: PropTypes.string.isRequired,
  handleTimeChange: PropTypes.func.isRequired
};

export default TimeDropdown;
